import  React from 'react';
import {NavLink, withRouter} from 'react-router-dom';
// import Scroll from 'react-scroll/modules';
import Divider from 'material-ui/Divider';
import {inject} from 'mobx-react'
import {
    SIDEBARS_BOTTOM_GUEST,
    SIDEBARS_TOP_GUEST,
    BUTTONS
} from '../../../constants/sideBar';

// let  LinkScroll = Scroll.Link;

@withRouter
@inject('sideBarStore')
export default class UserGuest extends React.Component {

    componentDidMount() {
        this.routerListener = this.props.history.listen(() => {
            this.props.sideBarStore.deactivate();
        });
    }

    componentWillUnmount() {
        this.routerListener();
    }

    handleHomePagePath(){
        this.props.location.pathname === '/';
    }

    render() {
        const topSidebarGuest = SIDEBARS_TOP_GUEST.map((item, index) => {
            const {icon, title, link} = item;

            return (
                <NavLink
                    key={index}
                    exact
                    to={link}
                    activeClassName="active"
                    className={`sidebar-item ${title === 'Live events' ? 'show-hide-side-bar-item' : ''}`}>
                    <i className={icon}/>
                    {title}
                </NavLink>
            )
        });
        const bottomSidebarGuest = SIDEBARS_BOTTOM_GUEST.map((item, index) => {
            const {icon, title, link} = item;

            return (
                <NavLink
                    key={index}
                    to={link}
                    exact
                    activeClassName="active"
                    className="sidebar-item">
                    <i className={icon}/>
                    {title}
                </NavLink>
            )
        });
        const buttons = BUTTONS.map((item, index) => {
            const {title, link} = item;

            return (
                <div className="button-set" key={index}>
                    <NavLink
                        to={link}
                        exact
                        activeClassName="active"
                        className="btn lightwhite bordered rounded">
                        {title}
                    </NavLink>
                </div>
            )
        });

        return (
            <div className="sidebar-wrapper">
                {topSidebarGuest}
                <Divider className="sidebar-divider"/>
                {bottomSidebarGuest}
                <Divider className="sidebar-divider"/>
                {buttons}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/core/containers/UserGuest.js